module.exports = __webpack_public_path__ + "media/images/payments/directdebit-b31876a4777251c7a6d1543c8dffb887.svg";